import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useSurveyTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
